// extracted by mini-css-extract-plugin
module.exports = {"answer_wrapper":"Hab","answer":"Had"};